import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeProps as _normalizeProps, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-7aeec97c"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "custom-log"
};
var _hoisted_2 = {
  class: "hostSummary"
};
var _hoisted_3 = {
  class: "num"
};
var _hoisted_4 = {
  class: "desc"
};
var _hoisted_5 = {
  class: "hostSummary"
};
var _hoisted_6 = {
  class: "mb-2 table cus-table"
};
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("tr", {
    class: "th"
  }, [/*#__PURE__*/_createElementVNode("th", null, "原料"), /*#__PURE__*/_createElementVNode("th", null, "重量/吨"), /*#__PURE__*/_createElementVNode("th", null, "单价/元"), /*#__PURE__*/_createElementVNode("th", null, "金额/元")], -1);
});
var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("td", null, null, -1);
});
var _hoisted_9 = {
  key: 1
};
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("td", {
    colspan: "4"
  }, "暂无数据", -1);
});
var _hoisted_11 = [_hoisted_10];
var _hoisted_12 = {
  class: "hostSummary"
};
var _hoisted_13 = {
  class: "mb-2 table cus-table"
};
var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("tr", {
    class: "th"
  }, [/*#__PURE__*/_createElementVNode("th", null, "原料"), /*#__PURE__*/_createElementVNode("th", null, "产量/方"), /*#__PURE__*/_createElementVNode("th", null, "销量/方"), /*#__PURE__*/_createElementVNode("th", null, "单价/元"), /*#__PURE__*/_createElementVNode("th", null, "金额/元")], -1);
});
var _hoisted_15 = {
  key: 1
};
var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("td", {
    colspan: "5"
  }, "暂无数据", -1);
});
var _hoisted_17 = [_hoisted_16];
var _hoisted_18 = {
  class: "hostSummary"
};
var _hoisted_19 = {
  class: "hostSummary"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_c_date_time_range_select = _resolveComponent("c-date-time-range-select");
  var _component_c_title = _resolveComponent("c-title");
  var _component_van_grid_item = _resolveComponent("van-grid-item");
  var _component_van_grid = _resolveComponent("van-grid");
  var _component_pie_echart = _resolveComponent("pie-echart");
  var _component_c_no_data = _resolveComponent("c-no-data");
  var _component_van_picker = _resolveComponent("van-picker");
  var _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_c_date_time_range_select, {
    class: "my-2",
    onConfirmDate: _ctx.confirmDatetime
  }, null, 8, ["onConfirmDate"]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_c_title, {
    title: "商砼总汇"
  }), _createVNode(_component_van_grid, {
    class: "grid mb-2",
    gutter: 10,
    "column-num": 3
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.summaryDataShangTong, function (item, index) {
        return _openBlock(), _createBlock(_component_van_grid_item, {
          key: index
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("span", _hoisted_3, _toDisplayString(item.num), 1), _createElementVNode("span", _hoisted_4, _toDisplayString(item.desc), 1)];
          }),
          _: 2
        }, 1024);
      }), 128))];
    }),
    _: 1
  })]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_c_title, {
    title: "采购总汇"
  }), _createElementVNode("table", _hoisted_6, [_hoisted_7, _ctx.receivingData.list.length ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.receivingData.list, function (item, index) {
    return _openBlock(), _createElementBlock("tr", {
      key: index
    }, [_createElementVNode("td", null, _toDisplayString(item.stone_name), 1), _createElementVNode("td", null, _toDisplayString(item.net_weight), 1), _createElementVNode("td", null, _toDisplayString(item.sale_price), 1), _createElementVNode("td", null, _toDisplayString(item.tot_money), 1)]);
  }), 128)), _createElementVNode("tr", null, [_createElementVNode("td", null, _toDisplayString(_ctx.receivingData.name), 1), _createElementVNode("td", null, _toDisplayString(_ctx.receivingData.sumWeight), 1), _hoisted_8, _createElementVNode("td", null, _toDisplayString(_ctx.receivingData.sumTotal), 1)])], 64)) : (_openBlock(), _createElementBlock("tr", _hoisted_9, _hoisted_11))])]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_c_title, {
    title: "销量总汇"
  }), _createElementVNode("table", _hoisted_13, [_hoisted_14, _ctx.saleData.length ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList(_ctx.saleData, function (item, index) {
    return _openBlock(), _createElementBlock("tr", {
      key: index
    }, [_createElementVNode("td", null, _toDisplayString(item.stone_name), 1), _createElementVNode("td", null, _toDisplayString(item.preload), 1), _createElementVNode("td", null, _toDisplayString(item.settle_value), 1), _createElementVNode("td", null, _toDisplayString(item.sale_price), 1), _createElementVNode("td", null, _toDisplayString(item.tot_money), 1)]);
  }), 128)) : (_openBlock(), _createElementBlock("tr", _hoisted_15, _hoisted_17))])]), _createElementVNode("div", _hoisted_18, [_createVNode(_component_c_title, {
    title: "商砼一号线"
  }), _ctx.mixtureData1.pieData.length ? (_openBlock(), _createBlock(_component_pie_echart, _normalizeProps(_mergeProps({
    key: 0
  }, _ctx.mixtureData1)), null, 16)) : (_openBlock(), _createBlock(_component_c_no_data, {
    key: 1,
    text: "未开机"
  }))]), _createElementVNode("div", _hoisted_19, [_createVNode(_component_c_title, {
    title: "商砼二号线"
  }), _ctx.mixtureData2.pieData.length ? (_openBlock(), _createBlock(_component_pie_echart, _normalizeProps(_mergeProps({
    key: 0
  }, _ctx.mixtureData2)), null, 16)) : (_openBlock(), _createBlock(_component_c_no_data, {
    key: 1,
    text: "未开机"
  }))]), _createVNode(_component_van_popup, {
    show: _ctx.lineShow,
    "onUpdate:show": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.lineShow = $event;
    }),
    position: "bottom"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_van_picker, {
        title: "请选择",
        columns: _ctx.lines,
        round: "",
        onConfirm: _ctx.onConfirmLine,
        onCancel: _ctx.onCancelLine
      }, null, 8, ["columns", "onConfirm", "onCancel"])];
    }),
    _: 1
  }, 8, ["show"])]);
}